import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import CtaButton from "@/components/shared/CtaButton";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found" description="The page you are looking for could not be found." path="/404" />
      <section className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6 pt-24">
        <span className="font-display text-8xl font-black tracking-tightest text-[#0B63F6]">404</span>
        <h1 className="font-display text-3xl font-bold tracking-tight mt-4">Page not found</h1>
        <p className="text-gray-600 mt-3 max-w-md">The page you&apos;re looking for doesn&apos;t exist or has moved. Let&apos;s get you back on track.</p>
        <div className="mt-8 flex flex-wrap gap-4 justify-center">
          <Link to="/" className="rounded-full bg-[#111111] text-white px-7 py-3.5 font-medium hover:bg-[#0B63F6] transition-colors">Back to home</Link>
          <CtaButton variant="outline" source="404" title="Talk to a GEO Expert">Talk to an expert</CtaButton>
        </div>
      </section>
    </>
  );
}
